/* @flow */
/* Do not edit - Generated by iconify. See README.md for more details. */
/* eslint-disable max-len */
import type { ElementConfig as ReactElementConfig } from "react"

import BaseIcon from "./BaseIcon";

export default class SvgIconChevronBack extends BaseIcon {
    static defaultProps: ReactElementConfig<typeof BaseIcon> = {
        iconClass: "ChevronBackIcon",
    }

    svgContent: string = `
        <svg class='${this.classNames}' version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" xml:space="preserve"><path fill="#231F20"  d="M37.929,19.043c0.281,0,0.563,0.107,0.777,0.322c0.43,0.429,0.43,1.126,0,1.555l-11.08,11.081 l11.08,11.079c0.43,0.43,0.43,1.127,0.001,1.556c-0.43,0.43-1.126,0.429-1.556,0.001L25.293,32.779 c-0.207-0.207-0.322-0.486-0.322-0.778s0.115-0.571,0.322-0.777l11.858-11.858C37.366,19.15,37.648,19.043,37.929,19.043z"></path></svg>
    `;
}
